import { Grid } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MuiPhoneNumber from "mui-phone-number";

const InputPhone = ({ label, value, onChange, disabled, error, InputProps = {}, ...rest }) => {
	return (
		<Grid
			size="grow"
			sx={{
				flexBasis: "16.666%", // 2 / 12 columns
				minWidth: "16.666%"
			}}
		>
			<MDBox
				{...rest}
				style={{
					backgroundColor: disabled ? "#f0f2f5" : "inherit"
				}}
				borderRadius="lg"
			>
				<MuiPhoneNumber
					defaultCountry="fr"
					onChange={e => onChange(e)}
					type="tel"
					className="dialogInput"
					label={label}
					value={value}
					variant="outlined"
					disabled={disabled}
					InputProps={InputProps}
					style={{
						height: "100%"
					}}
				/>
			</MDBox>
		</Grid>
	);
};
export default InputPhone;
